import { api } from "@/lib/api";

// Feature detection — never claim support where it isn't available.
export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandalone = () =>
  (typeof window !== "undefined") &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true);

export const isIOS = () =>
  typeof navigator !== "undefined" && /iP(hone|ad|od)/.test(navigator.userAgent);

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (e) {
    console.error("SW registration failed:", e);
    return null;
  }
}

function guessDeviceLabel() {
  const ua = navigator.userAgent;
  if (isIOS()) return "iPhone / iPad";
  if (/Android/.test(ua)) return "Android device";
  if (/Mac/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows PC";
  return "This device";
}

// Full enable flow: permission -> SW -> subscribe -> send to backend (bound server-side to the user).
export async function enablePush(label) {
  if (!pushSupported()) throw new Error("unsupported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");

  const reg = await registerServiceWorker();
  if (!reg) throw new Error("sw-failed");
  await navigator.serviceWorker.ready;

  const { data: keyData } = await api.get("/push/public-key");
  if (!keyData?.publicKey) throw new Error("no-key");

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(keyData.publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post("/admin/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    label: label || guessDeviceLabel(),
    user_agent: navigator.userAgent,
  });
  return true;
}
